import EmployeesListReducer from './List/store/slice'
import EmployeesFormReducer from './Form/store/slice'

const employeesReducers = {
  ...EmployeesListReducer,
  ...EmployeesFormReducer,
}

export default employeesReducers
